export const esiCountTotalResultsHtml = (totalResults: number) =>
    `<span class="esi-count">&nbsp;(${totalResults})</span>`

export const esiCountBeforeResultsHtml = (totalResults: number) =>
    `<span class="esi-before-count">${totalResults}&nbsp;</span>`

export const totalResultsHtml = (showTotalResults: boolean, totalResults: number) =>
    showTotalResults ? esiCountTotalResultsHtml(totalResults) : ``

// if showTotalResults is false we are on the old url style, so count should be before title
export const beforeHeaderTotalResultsHtml = (showTotalResults: boolean, totalResults: number) =>
    showTotalResults ? `` : esiCountBeforeResultsHtml(totalResults)

export const createHeadingHtml = (totalResults: number, title: string, showTotalResults: boolean) => {
    return `${beforeHeaderTotalResultsHtml(showTotalResults, totalResults)}
        <h1 id='fallback-h1'>${title || ""}</h1>
        ${totalResultsHtml(showTotalResults, totalResults)}`
}

export default createHeadingHtml
